import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { LeagueState } from "../store/constants";

export const selectLeaguesSlice = (state: RootState): LeagueState => state.leagues;

export const selectLeagues = createSelector(selectLeaguesSlice, (l) => l.value);

export const selectLeagueCategories = createSelector(selectLeaguesSlice, (l) => l.categories);

export const selectLeaguesStatus = createSelector(selectLeaguesSlice, (l) => l.status);

export const makeSelectLeagueById = (id: number | string) =>
  createSelector(selectLeagues, (leagues) => leagues.find((l) => String(l.id) === String(id)));


